// 基本信息按 itemCode 关联接口条数；使用过程信息保留固定收集说明。
export default {
  basic: [
    {
      name: "手机号",
      itemCode: "phoneNumber",
      purpose: "注册登录、短信验证、一键登录及账号安全验证",
      scenario: "手机号、短信验证码验证结果、微信授权手机号结果",
      content: "手机号、短信验证码验证结果、微信授权手机号结果",
    },
    {
      name: "头像",
      itemCode: "avatar",
      purpose: "在“我的”等页面识别当前账号",
      scenario: "账号头像",
      content: "可在【我的】模块中查看",
    },
    {
      name: "昵称/姓名",
      itemCode: "nickname",
      purpose: "展示当前账号、制单人等身份名称",
      scenario: "用户名、昵称或姓名",
      content: "可在【我的】模块中查看",
    },
    {
      name: "微信小程序账号",
      itemCode: "socialAccount",
      purpose: "支持微信身份识别、一键登录和手机号绑定",
      scenario: "一键登录、微信授权登录结果",
      content: "可在登录页面中使用第三方账号登录或绑定",
    },
  ],
  usage: [
    {
      name: "邮箱绑定与收票",
      purpose: "从绑定邮箱收取票据",
      scenario: "邮箱地址、邮箱验证码、绑定状态、收取进度",
      collectionStatus: "查询时返回记录",
      content: "用户转发邮件中的发票资料；页面展示邮箱地址、邮件主题和接收时间",
      path: "/email/list",
      linkText: "邮箱绑定",
    },
    {
      name: "短信收票",
      purpose: "从用户粘贴的短信中识别发票",
      scenario: "用户主动输入或粘贴的短信文本、识别结果",
      collectionStatus: "用户主动输入并确认时提交",
      content: "用户粘贴的短信全文及其中的发票信息或链接",
      path: "/message",
      linkText: "短信收取",
    },
    {
      name: "聊天文件及上传图片",
      purpose: "收集待处理的发票和单据",
      scenario: "首页→聊天导入、拍照上传、手工上传",
      collectionStatus: "用户选择文件或拍照后上传",
      content:
        "所选文件／图片内容、文件名；选择结果中的临时路径，页面校验文件大小",
      optionType: "chatting",
      linkText: "聊天导入",
    },
    {
      name: "微信卡包发票",
      purpose: "导入用户选择的微信卡包发票",
      scenario: "首页→微信卡包",
      collectionStatus: "用户选择发票后提交",
      content: "微信返回的所选发票信息，随后提交业务服务",
      optionType: "invoice",
      linkText: "微信卡包",
    },
    {
      name: "票据资料及操作",
      purpose: "展示、预览和维护票据",
      scenario: "底部电子发票／单据→预览、左滑编辑／删除、指定类型",
      collectionStatus: "读取已有票据；修改时提交用户操作",
      content:
        "票据标识、文件名与内容、购销方名称、金额、日期、事项、单据类型、查验及提交状态、驳回信息",
      path: "/bill",
      linkText: "单据列表",
    },
    {
      name: "查询筛选条件",
      purpose: "查询邮件和票据记录",
      scenario: "电子发票／单据筛选；邮件收取记录筛选",
      collectionStatus: "用户选择筛选项时提交查询",
      content: "日期范围、邮箱地址、票据类型、查验／提交状态及分页参数",
      path: "/bill",
      linkText: "单据列表",
    },
    {
      name: "关联财务软件/公司",
      purpose: "将票据提交至已绑定财务系统",
      scenario: "账套或公司名称、纳税人识别号、产品类型、绑定关系",
      collectionStatus: "用户确认提交时处理",
      content:
        "公司／账套名称和标识、产品类型、所选票据标识、事项、纸质档案标记及提交结果",
      path: "/company",
      linkText: "我的公司",
    },
    {
      name: "意见反馈",
      purpose: "接收和处理产品问题",
      scenario: "反馈内容、联系方式、最多四张反馈图片",
      collectionStatus: "点击提交时发送反馈",
      content: "意见描述、用户填写的联系方式、最多四张问题截图及图片标识",
      path: "/feedback",
      linkText: "意见反馈",
    },
  ],
};
